import { Link } from 'react-router-dom'
import { FooterItem } from './FooterItem/FooterItem';
import { CopyrightBox } from './CopyrightBox/CopyrightBox';
import { TextPage } from '../TextPage/TextPage';
import './Footer.scss'

const mir = require('./img/mir.png')
const visa = require('./img/visa.png')
const masterCard = require('./img/masterCard.png')
const sber = require('./img/sberPay.png')
const google = require('./img/googlePay.png')
const samsung = require('./img/samsungPay.png')


const footerItems = [

    {
        label: 'ПАРТНЕРАМ',
        subItems: [
            {
                label: 'Реферальная программа',
                path: 'https://ecomru.ru/ru/partners'
            },
        ],
    },
    {
        label: 'О компании',
        subItems: [
            {
                label: 'Миссия',
                path: 'https://ecomru.ru/ru/article/missija_kompanii_ecomseller/6815'
            },
            {
                label: 'О компании',
                path: 'https://ecomru.ru/ru/article/o_kompanii/6732'
            },
            {
                label: 'Новости',
                path: 'https://ecomru.ru/ru/articles/986'
            },
        ],
    },
    {
        label: 'ОБУЧЕНИЕ',
        subItems: [
            {
                label: 'Кейсы',
                path: 'https://ecomru.ru/ru/articles/987'
            },
            {
                label: 'Блог',
                path: 'https://ecomru.ru/ru/articles/986'
            }
        ],
    },
];

const transactionPlatforms = [
    mir, visa, masterCard, sber, google, samsung
]


const Footer = () => {
    return (
        <footer className="footer">
            <div className='footer__content'>
                <div className="footer__upper-box">
                    <nav className="footer__nav">
                        {footerItems.map(({ label, subItems, path }) => (
                            <FooterItem
                                key={label}
                                label={label}
                                subItems={subItems}
                                path={path}
                            />
                        ))}
                    </nav>

                    <div className="footer__org-info">
                        <TextPage
                            size={12}
                            text='Безналичный расчет для Юрлиц и ИП'
                        />
                        <div className="footer__icons">
                            {transactionPlatforms.map((el, ind) =>
                                <div className='footer__img-box' key={el + ind}>
                                    <img src={el} alt="Фото платежной платформы" />
                                </div>)}

                        </div>
                    </div>
                    <CopyrightBox />
                </div>
            </div>
        </footer>
    )
}

export { Footer }